// Doit rester synchronisé avec qrcode_server/src/config/authorizations.js
export const AUTHORIZATIONS = {
    TRACKED_QRCODES: 'tracked_qrcodes',
    PALETTES: 'palettes',
    DASHBOARD: 'dashboard',
    CUSTOM_DOMAINS: 'custom_domains',
    API_ACCESS: 'api_access',
    WORDPRESS_PLUGIN: 'wordpress_plugin',
    PRESTASHOP_PLUGIN: 'prestashop_plugin',
};
